import { createFileRoute } from "@tanstack/react-router";

import { FundraiserConnectRouteComponent } from "@/route-components/FundraiserConnectRouteComponent";

export const Route = createFileRoute("/_public/fundraiser-connect")({
  validateSearch: (search: Record<string, unknown>) => ({
    fundraiser_connect_requests_id:
      typeof search.fundraiser_connect_requests_id === "string" ? search.fundraiser_connect_requests_id : undefined,
  }),
  component: FundraiserConnectRouteComponent,
});
